/** @format */

import React from 'react';
import TextInput from 'src/ui/library/TextInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import SvgIcon from '@material-ui/core/SvgIcon';
import styled from 'src/ui/library/styled';
import intl from 'react-intl-universal';

const styles = theme => ({
  iconRoot: {
    marginLeft: '8px',
    position: 'absolute',
    right: '4px',
    top: '10px',
  },
});

const PickerInputHOC = (pickerRef, rootProps) => {
  class DatePickerInput extends React.Component {
    handleOnChange = event => {
      this.props.onChange(event);
      if (event.target.value === '') {
        rootProps.clearDate();
      }
    };

    handleKeyPress = event => {
      if (event.keyCode === 13 || event.keyCode === 27) {
        pickerRef().hideAfterDayClick();
        this.inputRef.blur();
      }
    };

    render() {
      const { classes, onChange, onKeyDown, readOnly = false, ...otherProps } = this.props;

      return (
        <TextInput
          type="text"
          name="text"
          inputProps={{ readOnly: readOnly }}
          label={rootProps.label || intl.get('controls.datePicker.default')}
          required={rootProps && rootProps.required ? true : false}
          placeholder={rootProps.label || intl.get('controls.datePicker.default')}
          styleType={'date'}
          inputRef={el => (this.inputRef = el)}
          disabled={rootProps.disabled}
          align={rootProps.align}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" style={{ marginTop: '0.9rem' }} classes={{ root: classes.iconRoot }}>
                <SvgIcon>
                  <path
                    fill="#2E2E38"
                    d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1"
                  />
                </SvgIcon>
              </InputAdornment>
            ),
          }}
          onKeyDown={this.handleKeyPress}
          onChange={this.handleOnChange}
          {...otherProps}
        />
      );
    }
  }

  return styled(DatePickerInput)(styles);
};

export default PickerInputHOC;
